import { useContext } from 'react';
import { HBUnauthenticatedStatsigProviderExistsContext } from '~/common/Statsig/Unauthenticated/HBUnauthenticatedStatsigProvider';

export const useIsWrappedWithUnauthenticatedStatsigProvider = () => {
    return useContext(HBUnauthenticatedStatsigProviderExistsContext);
};
